import template from './notifications.html';
import '../notifications.scss';

/**
 * @typedef  {Object}  Notification
 * @property {String}  content       the content to display.
 * @property {Boolean} expired       if the notification is expired or not.
 * @property {String}  type          the type of notifications to display.
 * @property {Boolean} visible       if the notification is visible or not.
 */

/**
 * @ngdoc component
 * @name odsNotifications
 * @description
 * The notifications component.
 */
export default {
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Array} notifications  the list of notifications to display.
   */
  bindings: {
    notifications: '<',
  },
};
